import makeUrl from './makeUrl/makeUrl'
import {
  CONTROLLER,
  TEST_CONFIG
} from '../routes'
import { Hyperlink } from '@eggplant/pattern-library'
import type { Props } from '../types'

interface Params {
  testConfigId: string
  tab?: 0 | 1 | 2
}

const LinkToEditTestConfigHyperlink = ({
  children,
  testConfigId,
  tab
}: (Props & Params)) => {
  const base = '/' + CONTROLLER + '/' + TEST_CONFIG + '/' + testConfigId

  const tabQueryParam = { tab }

  const url = tab
    ? makeUrl(base, tabQueryParam)
    : base

  return (
    <Hyperlink
      href={url}
      isExternal
    >
      {children}
    </Hyperlink>
  )
}

export default LinkToEditTestConfigHyperlink
